module.exports = __webpack_public_path__ + "static/img/isCore.db325416.png";